import { track } from "@/features/analytics";
import { useAuthStore } from "@/features/authentication";
import { useFileToStorydocStore } from "../stores/file-to-storydoc.store";
import {
  type ImportStore,
  selectIsImportPending,
} from "../stores/file-to-storydoc-generation.store";
import { getViewingImport } from "../stores/import-registry.store";

// Every import event carries its own import's job id so a funnel can be rebuilt per import (P0-14).
export const trackImport = (
  name: string,
  props: Record<string, unknown> = {},
  store: ImportStore | null = getViewingImport()?.store ?? null,
) => {
  const s = store?.getState();
  const local = useFileToStorydocStore.getState();
  const auth = useAuthStore.getState();
  track(`file import: ${name}`, {
    importJobId: s?.jobId ?? null,
    source: s?.source ?? local.source,
    entryPoint: s?.entryPoint ?? local.entryPoint,
    role: auth.claims ? auth.userType : null,
    ...props,
  });
};

// Back from step 3 keeps that import's upload; only then do step-2 events belong to its job.
const attemptJobId = () => {
  const viewing = getViewingImport()?.store.getState();
  const { pdfUrl } = useFileToStorydocStore.getState();
  if (!viewing || viewing.jobId == null || pdfUrl == null) return null;
  if (viewing.request?.pdfUrl !== pdfUrl || !selectIsImportPending(viewing))
    return null;
  return viewing.jobId;
};

export const trackImportPreJob = (
  name: string,
  props: Record<string, unknown> = {},
) =>
  trackImport(
    name,
    {
      source: useFileToStorydocStore.getState().source,
      entryPoint: useFileToStorydocStore.getState().entryPoint,
      importJobId: attemptJobId(),
      ...props,
    },
    null,
  );
